import { getAuth, signInWithPopup, signInWithRedirect, getRedirectResult, GoogleAuthProvider } from "firebase/auth";
import { createLogger } from '../../utils/logger';
import { isIOSOrMobileSafari } from '../../utils/browserUtils';

const logger = createLogger('GoogleAuthContext');

/** Use redirect on iOS - popup causes blank page after login on Safari. On localhost, authDomain is the Firebase project domain (SDK hardcodes https, so localhost would be unreachable). */
function shouldUseRedirect() {
  if (!isIOSOrMobileSafari()) return false;
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host.endsWith('.web.app') || host.endsWith('.firebaseapp.com');
}

export function googleAuth() {
  const provider = new GoogleAuthProvider();
  const auth = getAuth();

  provider.addScope('email');
  provider.addScope('profile');

  if (shouldUseRedirect()) {
    logger.debug('Using signInWithRedirect for iOS/Safari');
    return signInWithRedirect(auth, provider);
  }

  logger.debug('Using signInWithPopup');
  return signInWithPopup(auth, provider)
    .then((result) => result)
    .catch((error) => {
      const errorCode = error.code;
      if (errorCode === 'auth/popup-closed-by-user') {
        logger.debug('Google Authentication cancelled by user');
      } else {
        logger.error('Google Authentication Error', error, { errorCode, errorMessage: error.message });
      }
      throw error;
    });
}

/** Call on app load to process redirect result (required after signInWithRedirect on localhost) */
export function handleRedirectResult() {
  const auth = getAuth();
  return getRedirectResult(auth);
}